export default "<app-topo></app-topo>\n\n<router-outlet></router-outlet>\n\n<app-rodape></app-rodape>\n"